import baseRequest from './baseRequest';

const baseRoute = '/api/one-tap';

export const getOneTapValidationStatus = async (loanId: string): Promise<string> => {
  return (await baseRequest.get(`${baseRoute}/validation-status`, { params: { loanId } })).data;
};
